import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";

import VigilanteZonasSocialesService from "services/VigilanteZonasSocialesService";
import { notifySuccess, notifyError } from "../../components/CitoPlusToastr";

const ReporteAveriaModal = ({
  reservaUuid,
  show,
  onHide,
  onSuccess,
}) => {
  const [formData, setFormData] = useState({
    tipo: "averia",
    detalle: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.detalle.trim()) {
      notifyError("Debe ingresar el detalle del avería/faltante");
      return;
    }

    setLoading(true);
    try {
      await VigilanteZonasSocialesService.crearReporteAveria({
        reserva: reservaUuid,
        tipo: formData.tipo,
        detalle: formData.detalle.trim(),
      });

      notifySuccess("Reporte creado exitosamente");
      setFormData({ tipo: "averia", detalle: "" });
      onHide();

      // Callback para refrescar la lista de reportes
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error("Error creating reporte:", error);
      const message =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        "Error al crear el reporte";
      notifyError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleHide = () => {
    if (!loading) {
      setFormData({ tipo: "averia", detalle: "" });
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={handleHide} size="md">
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Reportar Avería/Faltante</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="vstack gap-3">
            <div>
              <Form.Label>Tipo de Reporte</Form.Label>
              <Form.Select
                name="tipo"
                value={formData.tipo}
                onChange={handleInputChange}
                disabled={loading}
                required
              >
                <option value="averia">Avería</option>
                <option value="faltante">Faltante</option>
              </Form.Select>
            </div>

            <div>
              <Form.Label>Detalle</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="detalle"
                value={formData.detalle}
                onChange={handleInputChange}
                placeholder="Describe la avería o faltante observado..."
                disabled={loading}
                required
              />
              <Form.Text className="text-muted">
                Proporcione una descripción detallada de la avería o faltante
              </Form.Text>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleHide} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={loading || !formData.detalle.trim()}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Creando...
              </>
            ) : (
              "Crear Reporte"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ReporteAveriaModal;
